<template>
  <div>
    <title-row
      title="Eszközlista"
      :breadcrumb-items="[{ text: 'Kulcsok és eszközök', disabled: true }]"
    >
      <template #buttons>
        <title-row-button v-if="hasRight('KEY_WRITE')" :to="{ name: 'NewAsset' }" title="Hozzáadás">
          <v-icon dark>mdi-plus</v-icon>
          Új eszköz
        </title-row-button>

        <title-row-button
          v-if="hasRight('KEY_WRITE')"
          @click="showImportDialog = true"
          title="Importálás fájlból"
        >
          <v-icon dark>mdi-file-import</v-icon>
          Import
        </title-row-button>
      </template>
    </title-row>

    <v-expansion-panels
      class="mb-4 rounded-xl overflow-hidden"
      :mandatory="!!Object.values(search).find((e) => e !== '')"
      flat
    >
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="font-weight-medium">
            <v-icon left>mdi-magnify</v-icon>
            Keresés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-2" align="end">
            <v-col :cols="12" :sm="4" :md="3">
              <v-text-field
                v-model="search.name"
                label="Megnevezés"
                dense
                clearable
                hide-details
                @input="searchEventHandler"
                v-mask="$config.inputMasks.name"
              />
            </v-col>
            <v-col :cols="12" :sm="4" :md="3">
              <v-autocomplete
                label="Kulcsszekrény"
                :items="asset_cabinets"
                item-text="name"
                item-value="id"
                v-model="search.asset_cabinet_id"
                :value-comparator="$config.comparators.isEqual"
                dense
                hide-details
                clearable
                @input="searchEventHandler"
              />
            </v-col>
            <v-col :cols="12" :sm="2" :md="2">
              <v-select
                label="Használatban"
                :items="[
                  { text: 'Igen', value: true },
                  { text: 'Nem', value: false },
                ]"
                v-model="search.taken"
                :value-comparator="$config.comparators.isEqual"
                dense
                hide-details
                clearable
                @input="searchEventHandler"
              />
            </v-col>
            <v-col :cols="12" :sm="4" :md="3">
              <v-btn color="primary" depressed @click="fetchItems">
                <v-icon left>mdi-magnify</v-icon>
                Szűrés
              </v-btn>
            </v-col>
            <!-- <v-col :cols="12" :sm="4" :md="3">
              <v-autocomplete
                label="Épület"
                :items="buildings"
                item-text="name"
                item-value="id"
                v-model="search.building_id"
                :value-comparator="$config.comparators.isEqual"
                hide-details
                clearable
                @input="searchEventHandler"
                filled
              />
            </v-col>
            <v-col :cols="12" :sm="4" :md="3">
              <v-autocomplete
                label="Szint"
                :items="building_levels"
                item-text="name"
                item-value="id"
                v-model="search.building_level_id"
                :disabled="!building_levels.length"
                hide-details
                :value-comparator="$config.comparators.isEqual"
                clearable
                @input="searchEventHandler"
                filled
              />
            </v-col> -->
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card flat :loading="loading" class="rounded-xl">
      <v-data-table
        :headers="dataTable.headers"
        :items="dataTable.items"
        :server-items-length="dataTable.itemsLength"
        :options.sync="dataTable.options"
        :footer-props="$config.dataTableFooterProps"
      >
        <template #[`item.status`]="{ item }">
          <v-icon
            v-if="item.taken_by"
            color="warning"
            :title="`A kulcsot elvitte: ${item.taken_by_name} (${item.taken_by_card_number})`"
          >
            mdi-close-box
          </v-icon>
          <v-icon v-else color="success" title="A kulcs a helyén van">mdi-checkbox-marked</v-icon>
        </template>

        <template #[`item.taken_by`]="{ item }">
          <div>
            <div>{{ item.taken_by_name }}</div>
            <div class="text-caption">{{ item.taken_by_card_number }}</div>
          </div>
        </template>

        <template #[`item.name`]="{ item }">
          <div class="d-flex align-center">
            <v-sheet
              :color="`${item.color || 'grey'}`"
              width="8"
              height="24"
              rounded="sm"
              class="mr-2"
            />
            <span class="font-weight-bold">{{ item.name }}</span>
          </div>
        </template>

        <template #[`item.cabinets`]="{ item }">
          <v-chip
            v-for="cabinet in item.cabinets"
            :key="cabinet.id"
            label
            link
            small
            :to="{ name: 'AssetCabinetList', params: { highlight: [cabinet.id] } }"
            class="ma-1"
          >
            {{ cabinet.name }}
          </v-chip>
        </template>
        <template #[`item.actions`]="{ item }">
          <v-btn
            v-if="hasRight('KEY_WRITE')"
            text
            fab
            small
            dark
            color="primary"
            class="rounded-sm mr-1"
            :to="{ name: 'AssetEditor', params: { id: item.element_id } }"
            title="Szerkesztés"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="hasRight('KEY_WRITE')"
            text
            fab
            small
            dark
            color="primary"
            class="rounded-sm mr-1"
            @click="deleteCardPermissions(item)"
            title="Kártyajogok törlése"
          >
            <v-icon color="error">mdi-card-remove</v-icon>
          </v-btn>
          <v-btn
            v-if="hasRight('KEY_WRITE')"
            text
            fab
            small
            dark
            color="primary"
            class="rounded-sm ma-1"
            @click="deleteAsset(item)"
            title="Archiválás"
          >
            <v-icon color="error">mdi-archive</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <import-dialog
      v-model="showImportDialog"
      @close="showImportDialog = false"
      @success="fetchAssets"
    />
  </div>
</template>

<script>
import { dataTablePage } from '@/mixins';
import ImportDialog from './ImportDialog.vue';

export default {
  mixins: [dataTablePage],

  components: {
    ImportDialog,
  },

  data() {
    return {
      showImportDialog: false,
      routeName: 'AssetList',
      fetchItems: this.fetchAssets,
      dataTable: {
        options: {
          sortBy: ['name'],
        },
        headers: [
          // { text: 'Szín', value: 'color', sortable: false, width: 60 },
          {
            text: 'Státusz',
            value: 'status',
            sortable: false,
            width: 60,
            align: 'center',
          },
          {
            text: 'Birtokló',
            value: 'taken_by',
          },
          {
            text: 'Megnevezés',
            value: 'name',
          },
          {
            text: 'Tároló',
            value: 'cabinets',
            sortable: false,
          },
          {
            text: 'Megjegyzés',
            value: 'remark',
            sortable: false,
          },
          {
            text: '',
            value: 'actions',
            sortable: false,
            align: 'end',
            width: 160,
          },
        ],
      },
      search: {
        name: '',
        taken: null,
        asset_cabinet_id: '',
        building_id: '',
        building_level_id: '',
      },
      groups: [],
      searchTimeout: null,
    };
  },

  methods: {
    // called before dataTablePage mixin's mounted event
    mounted() {
      this.search.asset_cabinet_id =
        this.search.asset_cabinet_id !== ''
          ? this.search.query.asset_cabinet_id
          : this.$store.getters.config.default_asset_cabinet_id;
    },

    parseSearchQueries() {
      return {
        name: this.$route.query.name,
        taken: this.$route.query.taken,
        asset_cabinet_id: this.$route.query.asset_cabinet_id,
        building_id: this.$route.query.building_id,
        building_level_id: this.$route.query.building_level_id,
      };
    },

    async deleteAsset(item) {
      const confirm = await this.$dialog.confirm({
        type: 'error',
        text: `<b>${item.name}</b> kulcs archiválására készül! Folytatja?`,
        title: 'Figyelem',
      });

      if (confirm) {
        try {
          await this.$http.post(`assets/archive/${item.element_id}`);
          this.fetchAssets();
          if (response.status === 'OK') {
            this.$dialog.notify.success('A kulcs archiválva');
          }
        } catch (e) {
          console.error(error);
        } finally {
          this.loading = false;
        }
      }
    },
    async deleteCardPermissions(item) {
      const confirm = await this.$dialog.confirm({
        type: 'error',
        text: `<b>${item.name}</b> kulcshoz tartozó kártyák jogainak törlésére készül! Folytatja?`,
        title: 'Figyelem',
      });

      if (confirm) {
        try {
          const response = await this.$http.post(
            `assets/delete-card-permissions/${item.element_id}`
          );
          this.fetchAssets();
          if (response.status === 'OK') {
            this.$dialog.notify.success(
              `A <b>${item.name}</b> kulcshoz tartozó kártyák jogai törölve`
            );
          }
        } catch (e) {
          console.error(error);
        } finally {
          this.loading = false;
        }
      }
    },

    async fetchAssets() {
      this.abortController?.abort();
      clearTimeout(this.searchTimeout);
      this.loading = true;
      try {
        const response = await this.$http.post('assets/list', this.postData);
        this.dataTable.items = response.assets;
        this.dataTable.itemsLength = response.assets_count;
        this.dataTable.options.page = Number(this.$route.query.page) || 1;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    searchQueries() {
      return {
        name: this.search.name || '',
        taken: this.search.taken ?? null,
        asset_cabinet_id: this.search.asset_cabinet_id || '',
        building_id: this.search.building_id || '',
        building_level_id: this.search.building_level_id || '',
      };
    },
  },

  asyncComputed: {
    asset_cabinets: {
      async get() {
        const response = await this.$http.post('asset-cabinets/list', {
          nolimit: true,
        });
        return response.asset_cabinets;
      },
      default: [],
    },
    // buildings: {
    //   async get() {
    //     this.building_levels = [];
    //     const response = await this.$http.post('buildings/list', {
    //       nolimit: true,
    //     });
    //     return response.buildings;
    //   },
    //   default: [],
    // },
    // building_levels: {
    //   async get() {
    //     if (this.search.building_id <= 0) {
    //       this.building_level_id = 0;
    //       this.search.building_level_id = 0;
    //       return [];
    //     }
    //     const response = await this.$http.post('building-levels/list', {
    //       building_id: this.search.building_id,
    //     });
    //     return response.building_levels;
    //   },
    //   default: [],
    // },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .key-tag {
  box-shadow: 0 0 2px #0008;
}

::v-deep .key-tag-hole {
  box-shadow: 0 0 2px inset #0008;
}

::v-deep .key-tag-label {
  box-shadow: 0 0 2px inset #0008;
}
</style>
